<template>
  <div>
    <div v-if="post.diffusions && post.diffusions.length > 0 && checkNbDiffusionsEnvoyees(post) > 0">
      <el-row v-for="diffusion in post.diffusions" :key="diffusion.id">
        <el-col v-if="diffusion.firstSentAt !== null && diffusion.envoyee === true" :lg="24">Diffusé le {{ convertDate(diffusion.firstSentAt)}}</el-col>
      </el-row>
    </div>
    <div v-if="post.planifications && post.planifications.length > 0">
      <el-row v-for="planification in post.planifications" :key="planification.id">
        <el-col v-if="planification.scheduled && planification.scheduled.lastExecution === null && planification.scheduled.status === '1'" :lg="24" style="padding-right: 8px;">Planifié le {{ convertDate(planification.scheduled.cronDate, true) }}</el-col>
      </el-row>
    </div>
    <div v-if="post.etat === 'B'" style="color: red;">Brouillon</div>
    <div v-else-if="!checkNbDiffusionsEnvoyees(post) > 0 && !(post.planifications && post.planifications.length > 0)">{{ (noDash)? '' : '-' }}</div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SocialPostsListTablePresence',
  props: {
    post: {
      type: Object,
      required: true
    },
    noDash: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkNbDiffusionsEnvoyees (post) {
      const networks = ['Instagram', 'Facebook', 'Google', 'Linkedin']
      // Je n'ai pas pris en compte Méta, il suffira de le rajouter au tableau de tri
      const validDiffuseurNames = post.diffusions.filter(item =>
        networks.some(network => item.diffuseurName.includes(network))
      ).map(item => item.diffuseurName)
      let nbEnvoyees = 0
      if (post.diffusions.length > 0) {
        post.diffusions.forEach(function (diffusion) {
          if (diffusion.envoyee === true && validDiffuseurNames.includes(diffusion.diffuseurName)) {
            nbEnvoyees += 1
          }
        })
      }
      return nbEnvoyees
    },
    convertDate (date, formatSql) {
      let dateMoment = null
      if (formatSql) {
        dateMoment = moment(date).format('DD/MM/YYYY à HH:mm')
      } else {
        dateMoment = moment(date, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY à HH:mm')
      }

      return dateMoment
    }
  }
}

</script>

<style scoped>

</style>
